export function toSnakeCase(str) {
  if (str) {
    return str.toLowerCase().trim().replace(/\s+/g, "_");
  }
  return;
}

export function snakeToNormal(str) {
  if (!str) return "";

  return str
    .replace(/_/g, ' ')            
    .toLowerCase()  
    .replace(/^./, c => c.toUpperCase()); 
}

export function getOrCreateGuestCartId() {
  let visitor = localStorage.getItem('visitor');
  if (!visitor) {
    visitor = 'guest_' + Math.random().toString(36).substring(2);
    localStorage.setItem('visitor', visitor);
  }
  return visitor;
}

export function clearGuestCartId() {
  localStorage.removeItem('visitor');
}